import { PATIENT_LIST_VIEWS } from "./helpers";

// this is the top tab navigation panel above the patient list table
function PatientListViews({ activeView, onViewChange }) {
    const tabs = PATIENT_LIST_VIEWS.map((view) => {
        const isActive = view.id === activeView;

        return (
            <div
                key={view.id}
                id={`patient-list-view-${view.id}`}
                onClick={() => onViewChange(view.id)}
                className={`flex-1 cursor-pointer border-x-[0.5px] border-y border-gray-300 py-2 text-center first:rounded-l first:border-l last:rounded-r last:border-r last:border-r-gray-300 ${
                    isActive
                        ? "border-b-primary-700 border-b-2 bg-blue-100"
                        : "hover:bg-blue-50 hover:font-medium"
                }`}
            >
                <span
                    id={`patient-list-view-txt-${view.id}`}
                    className={`text-sm ${
                        isActive
                            ? "text-primary-700 font-semibold"
                            : "text-neutral-700 active:font-medium"
                    }`}
                >
                    {view.label}
                </span>
            </div>
        );
    });

    return <div className="flex w-full rounded bg-white">{tabs}</div>;
}

export default PatientListViews;
